
$(function(){

	//スマホのhover無効 -----------------------------------------


	var touch = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

	if(touch) {
	try {
		for (var si in document.styleSheets) {
		var styleSheet = document.styleSheets[si];
		if (!styleSheet.rules) continue;

		for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
			if (!styleSheet.rules[ri].selectorText) continue;

			if (styleSheet.rules[ri].selectorText.match(':hover')) {
			styleSheet.deleteRule(ri);
			}
		}
		}
	} catch (ex) {}
	}


	/*
	* css swicher
	*/
	function css_browser_selector(u){
		var ua=u.toLowerCase(),
		is=function(t){return ua.indexOf(t)>-1},
		e='edge',g='gecko',w='webkit',s='safari',o='opera',m='mobile',
		h=document.documentElement,
		b=[
			( !(/opera|webtv/i.test(ua)) && /msie\s(\d)/.test(ua))? ('ie ie'+RegExp.$1) :
				!(/opera|webtv/i.test(ua)) && is('trident') && /rv:(\d+)/.test(ua)? ('ie ie'+RegExp.$1) :
				is('edge/')? e:
				is('firefox/2')?g+' ff2':
				is('firefox/3.5')? g+' ff3 ff3_5' :
				is('firefox/3.6')?g+' ff3 ff3_6':is('firefox/3')? g+' ff3' :
				is('gecko/')?g:
				is('opera')? o+(/version\/(\d+)/.test(ua)? ' '+o+RegExp.$1 :
				(/opera(\s|\/)(\d+)/.test(ua)?' '+o+RegExp.$2:'')) :
				is('konqueror')? 'konqueror' :
				is('blackberry')?m+' blackberry' :
				is('android')?m+' android' :
				is('chrome')?w+' chrome' :
				is('iron')?w+' iron' :
				is('applewebkit/')? w+' '+s+(/version\/(\d+)/.test(ua)? ' '+s+RegExp.$1 : '') :
				is('mozilla/')? g:
				'',
				is('j2me')?m+' j2me':
				is('iphone')?m+' iphone':
				is('ipod')?m+' ipod':
				is('ipad')?m+' ipad':
				is('mac')?'mac':
				is('darwin')?'mac':
				is('webtv')?'webtv':
				is('win')? 'win'+(is('windows nt 6.0')?' vista':''):
				is('freebsd')?'freebsd':
				(is('x11')||is('linux'))?'linux':
				'',
				'js'];
		c = b.join(' ');
		h.className += ' '+c;
		return c;
	};
	css_browser_selector(navigator.userAgent);



	/*==================================================
	tellink 
	==================================================*/
	if (navigator.userAgent.match(/(iPhone|iPod|Android)/)) {
	$(function() {
		$('.tellink').each(function() {
		var str = $(this).html();
		if ($(this).children().is('img')) {
			$(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/-/g, '')).append(str + '</a>'));
		} else {
			$(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/-/g, '')).append(str + '</a>'));
		}
		});
	});
	}


		//----------- scroll ----------------

		var state = false;
		//固定ヘッダーの指定
		var headerHeight = $('.l-header').outerHeight();
			
		// ページ外アンカーのページ付きリンクへのスムーススクロール
		var urlHash = location.hash;
		if(urlHash) {
			$('body,html').stop().scrollTop(0);
			setTimeout(function(){
				var target = $(urlHash);
				if($(".l-header").length){
					var position = target.offset().top - headerHeight;
				}else{
					var position = target.offset().top;
				}
				
				$('body,html').stop().animate({scrollTop:position}, 500);
			}, 100);
		}
		// ページ内アンカーのページ付きリンクへのスムーススクロール
	
		$('a[href*="#"], area[href*="#"]').not(".noScroll").click(function() {
	
			var speed = 400, // ミリ秒(この値を変えるとスピードが変わる)
				href = $(this).prop("href"), //リンク先を絶対パスとして取得
				hrefPageUrl = href.split("#")[0], //リンク先を絶対パスについて、#より前のURLを取得
				onUrl = location.href, //現在のページの絶対パスを取得
				onUrl = onUrl.split("#")[0]; //現在のページの絶対パスについて、#より前のURLを取得
	
			//#より前の絶対パスが、リンク先と現在のページで同じだったらスムーススクロールを実行
			if(hrefPageUrl == onUrl){
	
				//リンク先の#からあとの値を取得
				href = href.split("#");
				href = href.pop();
				href = "#" + href;
	
				//スムースクロールの実装
				if($(".l-header").length){
					var target = $(href == "#" || href == "" ? 'html' : href),
						position = target.offset().top - headerHeight; //targetの位置を取得
				}else{
					var target = $(href == "#" || href == "" ? 'html' : href),
						position = target.offset().top; //targetの位置を取得						
				}
				$('body,html').stop().animate({scrollTop:position}, speed);
	
				return false;
			}
	
		});



	/*---------- js-anime ---------------*/
	
	$(window).on('scroll', function (){
		var elem = $('.js-anime');
		var isAnimate = 'js-animeOn';
		elem.each(function () {
		var elemOffset = $(this).offset().top;
		var scrollPos = $(window).scrollTop();
		var wh = $(window).height();
		if(scrollPos > elemOffset - wh + (wh / 4) ){
			$(this).addClass(isAnimate);
			}
		});
	});
	
	$(window).on('load', function (){
		$('body').addClass('loaded');
		var isAnimate = 'js-animeOn';
		$(".js-anime2").addClass(isAnimate);
	});


	// mv 'new' animation 
	new Vivus( 'text-new', { // svgに指定するid名
		duration: 120, // アニメーションの長さ
		forceRender: false, //パスが更新で再レンダリングさせない
	});

	// products-bg width
	var bgWidthAdj = $(window).width() - $('.p-products__content').innerWidth();
	var boxWidth = $('.p-products__content .btm-inn').innerWidth();
	var bgWidth = boxWidth + bgWidthAdj / 2 ;
	var breakpoint = 896;
	$(window).on("resize orientationchange", function (e) {
		if (window.innerWidth > breakpoint) {
			$('.js-bgwidth').width(bgWidth) ;
		} else{
			$('.js-bgwidth').width() ;
		}
	}).trigger("resize");
	

	// products-img02 click
	$('.js-imgZoom').each(function() {
		$(this).on('click', function() {
			$(this).toggleClass('is-zoom');
		});
	});

	// products-img02 click　add
	// $('.js-imgChange').each(function() {
	// 	$(this).find('.js-imgChange-btn').on('click', function() {
	// 		$(this).toggleClass('is-change');
	// 	});
	// });
	$('.js-imgChange-btn').each(function() {
		$(this).on('click', function() {
			$(this).parents('.js-imgChange').toggleClass('is-change');
		});
	});

	/*-------------------------------------------
	animation(txt)
	-------------------------------------------*/

	function slideAnime() {
		$('.slide_left_anm').each(function() { 
			var elemPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			var threshold = windowHeight * (4 / 5); // ウィンドウの3/5の位置

			if (scroll >= elemPos - threshold) {
				$(this).addClass("slideAnimeLeftRight");
				$(this).children(".slide_left_anm_inner").addClass("slideAnimeRightLeft");
				// 一度アニメーションで表示されたら、その状態を維持する
				$(this).css({
					'opacity': '1',
					'transform': 'translateX(0)'
				});
				$(this).children(".slide_left_anm_inner").css({
					'opacity': '1',
					'transform': 'translateX(0)'
				});
			} 
			// スクロールが戻った時の処理は不要
		});
	}

	$(window).scroll(function() {
		slideAnime();
	});
});
$(function(){
    $.ajax({
        type: 'GET',
        url: 'https://graph.facebook.com/v3.0/17841411286911954?fields=name%2Cmedia.limit(12)%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Ctimestamp%2Cthumbnail_url%2Cmedia_type%2Cusername%7D&access_token=EAAIhrT9d7KYBO6IFg9S029TqqNyhBYC1vUzIBYl8szDedZBIjZCn1tYxKCUTwZCzZAmzISJ2UzBVbjc2OrKcr2PwptcoJaZAhspv7cwOICyngiR79UNIFJmSmRlSN8WmbgRc8aL0ZAVHgF1OjOy7J35lOU3mVD5rTuLXJaIZCf8Sj4EROTjCVmhsdYc',
        dataType: 'json',
        success: function(json) {
            let html = '';
            let insta = json.media.data;
            for (let i = 0; i < insta.length; i++) {
                let media_type = insta[i].media_type;
                if ( insta[i].media_type == "IMAGE" || insta[i].media_type == "CAROUSEL_ALBUM" ) {
                    html += '<li class="item"><a href="' + insta[i].permalink + '" target="_blank" rel="noopener" class="item-link"><img src="' + insta[i].media_url + '" alt=""></a></li>';
                } else if (media_type == "VIDEO" ) {
                    html += '<li class="item"><a href="' + insta[i].permalink + '" target="_blank" rel="noopener" class="item-link"><img src="' + insta[i].thumbnail_url + '" alt=""></a></li>';
                    let media_type = '';
                }
            }
            $("#instagram_gallery_list").append(html);
        },
        error: function() {
            //エラー時の処理
        }
    });
});